import React from 'react';
import clsx from 'clsx';
import { capitalizeFirst } from '../../utils/miscUtil';

interface StatusIndicator {
  variant: 'RUNNING' | 'STOPPED' | 'FAILED';
  text?: string;
}

const StatusIndicator = (props: StatusIndicator) => {
  let statusClassName;
  let colorClass;
  switch (props.variant) {
    case 'FAILED':
      statusClassName = 'status-error';
      colorClass = 'badge-danger';
      break;
    case 'STOPPED':
      statusClassName = 'status-stop';
      colorClass = 'badge-secondary';
      break;
    case 'RUNNING':
      statusClassName = 'status-run';
      colorClass = 'badge-success';
      break;
  }

  const title = capitalizeFirst(props.variant);

  return (
    <span className={clsx(statusClassName, colorClass, 'badge badge-pill')} title={title}>
      {props.text ? props.text : title}
    </span>
  );
};

export default StatusIndicator;
